import { AdminIcon } from './AdminIcon'
import styles from './Notice.module.css'

const ICON_MAP = {
  info: 'info',
  warning: 'warning',
  error: 'error',
  success: 'check',
}

/**
 * Informational, warning, and error callouts.
 */
export function Notice({ variant = 'info', title, children, className = '' }) {
  const variantClass = styles[variant] || styles.info
  const iconName = ICON_MAP[variant] || 'info'

  return (
    <div className={`${styles.notice} ${variantClass} ${className}`} role={variant === 'error' ? 'alert' : undefined}>
      <AdminIcon name={iconName} size={16} className={styles.icon} />
      <div className={styles.content}>
        {title && <span className={styles.title}>{title}</span>}
        {children && <span className={styles.body}>{children}</span>}
      </div>
    </div>
  )
}
